export default __webpack_public_path__ + "static/pc-hero-left-484211227016a48469eaf6df0da0e851.svg";